import { useSyncExternalStore } from "react";

import type { GenerationResult } from "../GenerationResult";
import { getGenerationResult, subscribeGenerationResult } from "../store/generationResultStore";

type UseGenerationResultReturn = {
    status: "idle" | "loading" | "loaded" | "error";
    result: GenerationResult | null;
};

export function useGenerationResult(
    taskId: string | null,
    projectId: string | null
): UseGenerationResultReturn {
    const entry = useSyncExternalStore(subscribeGenerationResult, () =>
        getGenerationResult(taskId, projectId)
    );

    if (!entry) return { status: "idle", result: null };
    return { status: entry.status, result: entry.result };
}
